module.exports = __webpack_public_path__ + "img/border4.e69a445d.png";